export default __webpack_public_path__ + "static/media/access_01.7f022b24.jpg";